/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { DocumentEditContext } from "cms/documents/document-selector/context/document-edit-context";
import { UploadDocument } from "cms/documents/upload-document";
import LabelledField from "components/labelled-field";
import { Fragment, useContext } from "react";

const DocumentDialogUploadPanel = () => {

    const {
        onDocumentUploaded,
        setSelectedDocument
    } = useContext(DocumentEditContext);

    const handleOnDocumentUploaded = (files) => {
        onDocumentUploaded(files);
        const firstFile = files[0];
        setSelectedDocument(firstFile);
    };

    return (
        <Fragment>
            <LabelledField variant="subtitle1" label='Upload Documents' >
                <div className='simplicity-upload-modal-frame'>
                    <section className='simplicity-upload-drop-container'>
                        <UploadDocument
                            onDocumentUploaded={handleOnDocumentUploaded}
                        />
                    </section>
                </div>
            </LabelledField>
        </Fragment>
    );
};

export { DocumentDialogUploadPanel };
